import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Service created due to circular dependency issues
@Injectable()
export class ServiceTicketScrollService {
  scrollTop$: Subject<void> = new Subject();

  constructor() {}
}
